export const vietnamPrimaryColor = "#ffd966"
export const vietnamPrimaryColorWithOpacity = (opacity: number) => `rgba(255,217,102,${opacity})`
export const vietnamPrimaryColorDarker = "#B88A00" // using contrast checker - lighthouse happy with #946F00
